<template>
  <GlobalLoadingBar :show="loading" />
  <Toast ref="toastRef" />
  <transition name="fade-page" mode="out-in">
    <router-view />
  </transition>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import GlobalLoadingBar from './components/GlobalLoadingBar.vue'

const loading = ref(false)
const router = useRouter()
const toastRef = ref(null)
onMounted(() => {
  window.$toast = toastRef.value
  router.beforeEach((to, from, next) => {
    loading.value = true
    next()
  })
  router.afterEach(() => {
    setTimeout(() => {
      loading.value = false
    }, 400)
  })
})
</script>

<style>
body{
  padding: 0;
  margin: 0;
}
/* 页面切换淡入淡出动画 */
.fade-page-enter-active, .fade-page-leave-active {
  transition: opacity 0.35s cubic-bezier(.4,0,.2,1);
}
.fade-page-enter-from, .fade-page-leave-to {
  opacity: 0;
}
/* 通用可滚动区域美化 */
/* 鼠标悬浮时才显示滚动条 */
.scrollable-area {
  overflow-y: auto;
}
.scrollable-area::-webkit-scrollbar {
  width: 0;
  background: transparent;
  transition: width 0.2s;
}
.scrollable-area:hover::-webkit-scrollbar {
  width: 8px;
}
.scrollable-area::-webkit-scrollbar-track {
  background: #fff;
  border-radius: 10px;
}
.scrollable-area::-webkit-scrollbar-thumb {
  background: rgba(144,147,153,.2);
  border-radius: 10px;
}
.scrollable-area::-webkit-scrollbar-thumb:hover {
  background: rgba(144,147,153,.4);
}
#app ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background: transparent;
}
#app ::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #FFB347 0%, #FF7A00 100%);
  border-radius: 6px;
  min-height: 30px;
  transition: background 0.2s;
}
#app ::-webkit-scrollbar-thumb:hover {
  background: #FF7A00;
}
#app ::-webkit-scrollbar-track {
  background: transparent;
}
#app ::-webkit-scrollbar-button:single-button {
  display: block;
  background: #fff;
  border-radius: 50%;
  border: 1px solid #FF7A00;
  width: 18px;
  height: 18px;
  margin: 2px 0;
}
#app ::-webkit-scrollbar-button:single-button:vertical:decrement {
  background: url('data:image/svg+xml;utf8,<svg width="12" height="12" xmlns="http://www.w3.org/2000/svg"><polygon points="6,3 11,9 1,9" fill="%23FF7A00"/></svg>') no-repeat center center;
  background-size: 12px 12px;
}
#app ::-webkit-scrollbar-button:single-button:vertical:increment {
  background: url('data:image/svg+xml;utf8,<svg width="12" height="12" xmlns="http://www.w3.org/2000/svg"><polygon points="1,3 11,3 6,9" fill="%23FF7A00"/></svg>') no-repeat center center;
  background-size: 12px 12px;
}
#app ::-webkit-scrollbar-button:single-button:horizontal:decrement {
  background: url('data:image/svg+xml;utf8,<svg width="12" height="12" xmlns="http://www.w3.org/2000/svg"><polygon points="9,1 3,6 9,11" fill="%23FF7A00"/></svg>') no-repeat center center;
  background-size: 12px 12px;
}
#app ::-webkit-scrollbar-button:single-button:horizontal:increment {
  background: url('data:image/svg+xml;utf8,<svg width="12" height="12" xmlns="http://www.w3.org/2000/svg"><polygon points="3,1 9,6 3,11" fill="%23FF7A00"/></svg>') no-repeat center center;
  background-size: 12px 12px;
}
html, body, #app {
  scrollbar-width: thin;
  scrollbar-color: #FF7A00 #f0f0f0;
}
#app {
  font-family: Avenir, Helvetica, Arial, 'FontAwesome', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.load-more-btn {
  margin: 18px auto 0 auto;
  display: block;
  background: #ff7a00;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 24px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.load-more-btn:hover {
  background: #e66a00;
}
</style>
